import ShippingProviderLocations from './ShippingProviderLocations';

export default ShippingProviderLocations;
